fileUploadCtrl.$inject = ['$scope', 'Upload', '$window', '$timeout', 'events', 'configuration']
export default function fileUploadCtrl($scope, Upload, $window, $timeout, events, config) {
  $scope.processing = false

  $scope.onFileSelect = function($files) {
    $scope.file = $files[0]
    // $scope.upload();
  }

  $scope.upload = function() {
    var url = config.apiEndPoint + '/test_upload_csv'
    $scope.processing = true
    $scope.uploadPromise = Upload.upload({
      url: url,
      file: $scope.file,
      method: 'POST'
    })
    $scope.uploadPromise.then(
      function(uploadResponse) {
        $scope.uploadCallback(uploadResponse)
      },
      function(reason) {
        $scope.processing = false
        $window.alert(reason)
      }
    )
  }

  $scope.uploadCallback = function(uploadResponse) {
    console.log(uploadResponse)
    $scope.responseData = uploadResponse.data

    // any controllers that catch this event must be a parent controller
    $scope.$emit(events.FILE_UPLOADED, uploadResponse)
    $scope.processing = false
  }
}
